import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";

export enum MessagingTemplateDetailsActionTypes {
    // Messaging Template Details
    SET_MESSAGING_TEMPLATE_DETAILS_LOADING = "SET_MESSAGING_TEMPLATE_DETAILS_LOADING",
    SET_MESSAGING_TEMPLATE_DETAILS = "SET_MESSAGING_TEMPLATE_DETAILS"
}

// Messaging Template Details
type SetMessagingTemplateDetailsLoadingAction = {
    type: MessagingTemplateDetailsActionTypes.SET_MESSAGING_TEMPLATE_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setMessagingTemplateDetailsLoading = (isLoading: boolean): SetMessagingTemplateDetailsLoadingAction => ({
    type: MessagingTemplateDetailsActionTypes.SET_MESSAGING_TEMPLATE_DETAILS_LOADING,
    payload: { isLoading }
});

type SetMessagingTemplateDetailsAction = {
    type: MessagingTemplateDetailsActionTypes.SET_MESSAGING_TEMPLATE_DETAILS,
    payload: { messagingTemplate: FormattedMessagingTemplate; }
}

export const setMessagingTemplateDetails = (messagingTemplate: FormattedMessagingTemplate): SetMessagingTemplateDetailsAction => ({
    type: MessagingTemplateDetailsActionTypes.SET_MESSAGING_TEMPLATE_DETAILS,
    payload: { messagingTemplate }
});


export type MessagingTemplateDetailsActions =
    // Messaging Template Details
    SetMessagingTemplateDetailsLoadingAction |
    SetMessagingTemplateDetailsAction